import { JoinData } from './JoinDataInt';

const leftOuterButtonsX = 129;
const topOuterButtonsY = 103;
const rightOuterButtonsX = 1156;
const bottomOuterButtonsY = 553;

const outerButtonsHeight = 100;
const outerButtonsWidth = 100;

const innerButtonsHeight = 50;
const innerButtonsWidth = 153;

const leftButtonsX = 228;
const rightButtonsX = 1004;

const innerFirstRowY = 228;
const innerSecondRowY = 299;
const innerThirdRowY = 369;
const innerFourthRowY = 439;

const transportControlY = 557;
const transportControlHeight = 40;

const category = "room_video_kaleidescape";

const roomVideoKaleidescape: JoinData[] = [
    { join: "digital-press-45", name: "Back", x: 129, y: 32, width: 53, height: 36, category },
    { join: "serial-feedback-2", name: "Room Name", x: 642, y: 23, width: 100, height: 32, category },

    { join: "digital-feedback-90", name: "Select Source Feedback", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "digital-press-90", name: "Select Source", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "serial-feedback-12", name: "Video Source Name", x: 969, y: 31, width: 159, height: 44, category },
    { join: "digital-press-122", name: "Video Power Off", x: 1225, y: 35, width: 30, height: 30, category },

    // { join: "svg_8", name: "Open Sharing Menu", x: 1211, y: 735, width: 45, height: 46, category },
    { join: "digital-feedback-91", name: "Video Mute Feedback", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-91", name: "Video Mute", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-95", name: "Video Volume Down", x: 644, y: 741, width: 39, height: 39, category },
    { join: "analog-feedback-1", name: "Current Volume", x: 707, y: 745, width: 25, height: 30, category },
    { join: "digital-press-94", name: "Video Volume Up", x: 753, y: 741, width: 39, height: 39, category },

    { join: "digital-feedback-10", name: "Display Toggle Visibility", x: 1144, y: 23, width: 75, height: 51, category },
    { join: "digital-feedback-9", name: "Display Toggle Feedback", x: 1176, y: 35, width: 43, height: 30, group: 'display_toggle', category },
    { join: "digital-press-9", name: "Display Toggle Press", x: 1176, y: 35, width: 43, height: 30, group: 'display_toggle', category },

    { join: "digital-press-337", name: "Back", x: leftOuterButtonsX, y: topOuterButtonsY, width: outerButtonsWidth, height: outerButtonsHeight, category },
    { join: "digital-press-298", name: "Closed Captioning", x: leftOuterButtonsX, y: bottomOuterButtonsY, width: outerButtonsWidth, height: outerButtonsHeight, category },
    { join: "digital-press-347", name: "Movie List", x: leftButtonsX, y: innerFirstRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-348", name: "Movie Collections", x: leftButtonsX, y: innerSecondRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-349", name: "Movie Covers", x: leftButtonsX, y: innerThirdRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-350", name: "Movie Arrange", x: leftButtonsX, y: innerFourthRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },

    { join: "digital-feedback-367", name: "Custom Message Visibility", x: 537, y: 634, width: 303, height: innerButtonsHeight, category },
    { join: "serial-feedback-55", name: "Custom Message", x: 537, y: 634, width: 303, height: innerButtonsHeight, category },

    { join: "digital-press-345", name: "Intermission", x: 616, y: 103, width: innerButtonsWidth, height: innerButtonsHeight, category },

    { join: "digital-press-326", name: "Previous", x: 500, y: transportControlY, width: 45, height: transportControlHeight, category },
    { join: "digital-press-324", name: "Rewind", x: 588, y: transportControlY, width: 45, height: transportControlHeight, category },
    { join: "digital-press-321", name: "Play/Pause", x: 670, y: transportControlY, width: 45, height: transportControlHeight, category },
    { join: "digital-press-323", name: "Fast Forward", x: 754, y: transportControlY, width: 45, height: transportControlHeight, category },
    { join: "digital-press-325", name: "Next", x: 839, y: transportControlY, width: 45, height: transportControlHeight, category },

    { join: "digital-press-302", name: "Down", x: 654, y: 423 - 33, width: 77, height: 35, category },
    { join: "digital-press-305", name: "Select", x: 630, y: 276 - 33, width: 124, height: 123, category },
    { join: "digital-press-303", name: "Left", x: 570, y: 300 - 33, width: 35, height: 77, category },
    { join: "digital-press-301", name: "Up", x: 654, y: 215 - 33, width: 77, height: 35, category },
    { join: "digital-press-304", name: "Right", x: 779, y: 300 - 33, width: 35, height: 77, category },

    { join: "digital-press-346", name: "Search", x: rightOuterButtonsX, y: topOuterButtonsY, width: outerButtonsWidth, height: outerButtonsHeight, category },
    { join: "digital-press-351", name: "Music List", x: rightButtonsX, y: innerFirstRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-352", name: "Music Collections", x: rightButtonsX, y: innerSecondRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-353", name: "Music Covers", x: rightButtonsX, y: innerThirdRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-354", name: "Music Arrange", x: rightButtonsX, y: innerFourthRowY, width: innerButtonsWidth, height: innerButtonsHeight, category },
    { join: "digital-press-329", name: "Menu", x: rightOuterButtonsX, y: bottomOuterButtonsY, width: outerButtonsWidth, height: outerButtonsHeight, category },
];

export default roomVideoKaleidescape;
